import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Gelar jabatan gerejawi di depan nama (Pdt./Ev./Dkn.); tanpa jabatan → nama apa adanya
export const GELAR_GEREJAWI = { Pendeta: "Pdt.", Evangelis: "Ev.", Diaken: "Dkn." };
export const gelar = (jabatan) => GELAR_GEREJAWI[jabatan] || "";
export const namaGelar = (j) => { if (!j) return ""; const g = gelar(j.jabatan_gerejawi); const n = j.nama_lengkap || j.nama || ""; return g ? `${g} ${n}` : n; };
